import * as form from '../form';

export const financialFederalDebt = (data = {}) => {
  const federalDebtItems = (data = {}) => (data?.items || []).map((x) => {
    const xitem = x?.Item || {};
    return {
      Item: {
        FederalDebtType: form.radio(xitem.FederalDebtType),
        FederalDebtTypeReason: form.textarea(xitem.FederalDebtTypeReason),
        Year: form.datecontrol(xitem.Year),
        Reason: form.textarea(xitem.Reason),
        ReasonNoActions: form.textarea(xitem.ReasonNoActions),
        Intent: form.radio(xitem.Intent),
        Date: form.datecontrol(xitem.Date),
        Amount: form.text(xitem.Amount),
        AmountIDK: form.notapplicable(xitem.AmountIDK),
        AmountEstimated: form.checkbox(xitem.AmountEstimated),
        JudgementAmount: form.text(xitem.JudgementAmount),
        ActionsTaken: form.checkboxgroup(xitem.ActionsTaken),
        ActionsTakenReason: form.textarea(xitem.ActionsTakenReason),
        Agency: form.text(xitem.Agency),
        CourtName: form.text(xitem.CourtName),
        CourtLocation: form.location(xitem.CourtLocation),
        AccountNum: form.text(xitem.AccountNum),
        PropertyType: form.text(xitem.PropertyType),
        PropertyTypeNotApplicable: form.notapplicable(xitem.PropertyTypeNotApplicable),
        HasJudgementOrLien: form.branch(xitem.HasJudgementOrLien),
        JudgementOrLien: form.radio(xitem.JudgementOrLien),
      },
    };
  });
  return {
    HasFailedToPay: form.branch(data.HasFailedToPay),
    HasFailedToFile: form.branch(data.HasFailedToFile),
    HasOther: form.branch(data.HasOther),
    FailedToPayList: form.collection(federalDebtItems(data.FailedToPayList), (data.FailedToPayList || {}).branch),
    FailedToFileList: form.collection(federalDebtItems(data.FailedToFileList), (data.FailedToFileList || {}).branch),
    OtherList: form.collection(federalDebtItems(data.OtherList), (data.OtherList || {}).branch),
  };
};
